<template>
    <multiselect
        id="customer_select"
        :placeholder="$t('Insert business name or VAT number')"
        :limit="5"
        :searchable="true"
        :internal-search="false"
        :show-no-results="true"
        open-direction="bottom"
        @search-change="searchCustomer"
        :custom-label="customerInfo"
        :options="filteredCustomers"
        :value="value"
        @input="updateCustomer"
        >
        <template slot="clear">
            <div
                class="multiselect__clear"
                v-if="value"
                @mousedown.prevent.stop="clearCustomer()"
            ></div>
        </template>
        <span slot="noResult">
                      {{ $t('No customers found') }}
                    </span>
        <span slot="noOptions">
                      {{ $t('No customers found') }}
                    </span>
    </multiselect>
</template>
<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
//import {mapState} from 'vuex';

export default {
    name: "CustomerSelect",
    components: {
        Multiselect,
    },
    props: {
        withDemo: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            type: Object,
            required: false,
            default: null
        }
    },
    data: () => ({
        loading: true,
        filteredCustomers: [],
        customers: [],
    }),
    mounted() {
        this.getCustomers();
    },
    methods: {
        searchCustomer(query) {
            if(query === '') return;
            let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/customers?with-demo=${this.withDemo}&filter[like_name_or_vat_number]=${query}`;
            axios
                .get(url)
                .then((response) => {
                    this.customers = response.data.data;
                    this.filteredCustomers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error.stack);
                });
        },
        customerInfo({ name, vat_number }) {
            return `${name} — ${vat_number}`;
        },
        getCustomers: function() {
            let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/customers`;
            axios
                .get(url)
                .then((response) => {
                    this.customers = response.data.data;
                    this.filteredCustomers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error.stack);
                });
        },
        clearCustomer($event) {
            this.$emit("input", null);
        },
        updateCustomer(customer) {
            this.$emit("input", customer);
        },
    },
};
</script>
